import { useLocation } from "react-router-dom";
import { createContext, useContext, useState, useEffect } from "react";
import APIFunction from "../util/api";
import { ERROR_MESSAGES } from "../util/constants";

const SharedDataContext = createContext(null);

export const SharedDataProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [summery, setSummery] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  
  const fetchData = async () => {
        try {
            setLoading(true);
            const userOverview = await APIFunction.getUserSummery();
            const packageSummary = await APIFunction.getProfileSummery();
            setData(userOverview);
            setSummery(packageSummary);
        } catch (err) {
            console.error(ERROR_MESSAGES.ERROR_SHARED_DATA, err);
        } finally {
            setLoading(false);
        }
    }

  useEffect(() => {
    fetchData();
  }, [location.pathname]);

  return (
    <SharedDataContext.Provider value={{data, loading, summery}}>
      {children}
    </SharedDataContext.Provider>
  );
};

export const useSharedData = () => useContext(SharedDataContext);
